import {styled} from '@mui/material';
import {TagChip} from 'presentation/components';

const StyledChip = styled(TagChip)`
	max-width: 64%;

	& .MuiChip-label {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
`;

export {StyledChip};
